<template>
  <div style="display: flex">
    <div class="media" style="display: flex; align-items: center; position: relative; flex-grow: 1">
      <div style="padding-left: 0.25rem; padding-top: 0.5rem; padding-right: 0.5rem; padding-bottom: 0.25rem">
        <img style="border-radius: 50%; width: 50px; height: 50px" src=""  />
      </div>
      <div class="media-body" style="flex-grow: 1; padding-left: 0.5rem">
        <div style="padding-top: 0.25rem; padding-right: 0.5rem">
          <span>名無しさん</span>
        </div>
      </div>
    </div>
  </div>
</template>